import Vue from 'vue'
import Vuex from 'vuex'

// eslint-disable-next-line camelcase
import model_pramers from './model_pramers'

import login from './login'

Vue.use(Vuex)

const store = new Vuex.Store(
  {
    modules: {
      model_pramers: model_pramers,
      login:login
    }
  }
)
export default store



// WEBPACK FOOTER //
// ./src/store/store.js